import type { DriveStep } from 'driver.js';
import { accountsTour } from './accounts';
import { budgetTour } from './budget';
import { businessTour } from './business';
import { goalsTour } from './goals';
import { homeTour } from './home';
import { investTour } from './invest';
import { planTour } from './plan';
import { reportsTour } from './reports';
import { transactionsTour } from './transactions';

/**
 * First-run guided tours (driver.js). Each route can name one via `handle.tourId` (or a page via `PageHeader tourId`);
 * TourProvider runs it once, the first time the route is visited (if its anchors are on screen). Anchors are
 * `data-tour="…"` attributes.
 */
export interface TourDef {
  readonly id: string;
  readonly steps: readonly DriveStep[];
}

export const TOURS: Readonly<Record<string, TourDef>> = Object.fromEntries(
  [homeTour, accountsTour, transactionsTour, budgetTour, goalsTour, planTour, businessTour, investTour, reportsTour].map((t) => [t.id, t]),
);

/** CSS selector for a `data-tour` anchor. */
export const anchor = (id: string): string => `[data-tour="${id}"]`;
